import {Routes} from '@angular/router';
import {AuthGuard} from './auth.guard';
import {PageComponent} from "./page/page.component";
import {RegionListComponent} from "./page/region/region-list.component";
import {RegionDetailComponent} from "./page/region/region-detail.component";
import {UserListComponent} from "./page/user/user-list.component";
import {UserDetailComponent} from "./page/user/user-detail.component";
import {DashboardComponent} from "./page/dashboard.component";
import {SettingsComponent} from "./page/settings.component";
import {LoginComponent} from "./page/login.component";
import {ErrorsComponent} from "./errors/errors.component";
import {PageNotFoundComponent} from "./errors/page-not-found.component";
import {PositionListComponent} from "./page/position/position-list.component";
import {PositionDetailComponent} from "./page/position/position-detail.component";
import {CountryListComponent} from "./page/country/country-list.component";
import {CountryDetailComponent} from "./page/country/country-detail.component";
import {FranchisorListComponent} from "./page/franchisor/franchisor-list.component";
import {FranchisorDetailComponent} from "./page/franchisor/franchisor-detail.component";
import {FranchiseeListComponent} from "./page/franchisee/franchisee-list.component";
import {FranchiseeDetailComponent} from "./page/franchisee/franchisee-detail.component";
import {StoreListComponent} from "./page/store/store-list.component";
import {StoreDetailComponent} from "./page/store/store-detail.component";
import {InvoiceComponent} from "./page/invoice.component";
import {ReportComponent} from "./page/report.component";
import {HandleTokenComponent} from "./page/handle-token.component";
import {TurnoverComponent} from "./page/turnover.component";
import {KpiComponent} from "./page/kpi.component";
import {MapsComponent} from "./page/maps.component";
import {ProductCheck} from "./page/product/product-check";
import {ProductGroupListComponent} from "./page/product/product-group/product-group-list.component";
import {
    ProductGroupDetailComponent
} from "./page/product/product-group/product-group-detail.component";
import {ProductListComponent} from "./page/product/product/product-list.component";
import {ProductDetailComponent} from "./page/product/product/product-detail.component";
import {ClientGuard} from "./client.guard";
import {InvoiceTypeListComponent} from "./page/invoice-type/invoice-type-list.component";
import {InvoiceTypeDetailComponent} from "./page/invoice-type/invoice-type-detail.component";
import {PriceListListComponent} from "./page/price-list/price-list-list.component";
import {PriceListDetailComponent} from "./page/price-list/price-list-detail.component";
import {ProductEvaluationComponent} from "./page/product/product-evaluation.component";
import {SupplierListComponent} from "./page/supplier/supplier-list.component";
import {SupplierDetailComponent} from "./page/supplier/supplier-detail.component";
import {SupplierProductListComponent} from "./page/supplier-product/supplier-product-list.component";
import {SupplierProductDetailComponent} from "./page/supplier-product/supplier-product-detail.component";
import {ContactCategoryListComponent} from "./page/contact-category/contact-category-list.component";
import {ContactCategoryDetailComponent} from "./page/contact-category/contact-category-detail.component";
import {ContactListComponent} from "./page/contact/contact-list.component";
import {ContactDetailComponent} from "./page/contact/contact-detail.component";
import {GenericListListComponent} from "./page/generic-list/generic-list-list.component";
import {GenericListDetailComponent} from "./page/generic-list/generic-list-detail.component";
import {SupplierPriceListListComponent} from "./page/supplier-price-list/supplier-price-list-list.component";
import {SupplierPriceListDetailComponent} from "./page/supplier-price-list/supplier-price-list-detail.component";

export const routes: Routes = [
    {
        path: '',
        component: PageComponent,
        canActivate: [AuthGuard, ClientGuard],
        //runGuardsAndResolvers: 'always',
        data: {title: 'Home'},
        children: [
            {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
            {path: 'region', component: RegionListComponent},
            {path: 'region/:id', component: RegionDetailComponent},
            {path: 'position', component: PositionListComponent},
            {path: 'position/:id', component: PositionDetailComponent},
            {path: 'country', component: CountryListComponent},
            {path: 'country/:id', component: CountryDetailComponent},
            {path: 'franchisor', component: FranchisorListComponent},
            {path: 'franchisor/:id', component: FranchisorDetailComponent},
            {path: 'franchisee', component: FranchiseeListComponent},
            {path: 'franchisee/:id', component: FranchiseeDetailComponent},
            {path: 'store', component: StoreListComponent},
            {path: 'store/:id', component: StoreDetailComponent},
            {path: 'user', component: UserListComponent},
            {path: 'user/:id', component: UserDetailComponent},
            {path: 'dashboard', component: DashboardComponent},
            {path: 'invoice', component: InvoiceComponent},
            {path: 'report', component: ReportComponent},
            {path: 'settings', component: SettingsComponent},
            {path: 'turnover', component: TurnoverComponent},
            {path: 'kpi', component: KpiComponent},
            {path: 'maps', component: MapsComponent},
            {path: 'productcheck', component: ProductCheck},
            {path: 'productgroup', component: ProductGroupListComponent},
            {path: 'productevaluation', component: ProductEvaluationComponent},
            {path: 'productgroup/:id', component: ProductGroupDetailComponent},
            {path: 'product', component: ProductListComponent},
            {path: 'product/:id', component: ProductDetailComponent},
            {path: 'invoicetype', component: InvoiceTypeListComponent},
            {path: 'invoicetype/:id', component: InvoiceTypeDetailComponent},
            {path: 'pricelist', component: PriceListListComponent},
            {path: 'pricelist/:id', component: PriceListDetailComponent},
            {path: 'supplier', component: SupplierListComponent},
            {path: 'supplier/:id', component: SupplierDetailComponent},
            {path: 'supplierproduct', component: SupplierProductListComponent},
            {path: 'supplierproduct/:id', component: SupplierProductDetailComponent},
            {path: 'contactcategory', component: ContactCategoryListComponent},
            {path: 'contactcategory/:id', component: ContactCategoryDetailComponent},
            {path: 'contact', component: ContactListComponent},
            {path: 'contact/:id', component: ContactDetailComponent},
            {path: 'list', component: GenericListListComponent},
            {path: 'list/:id', component: GenericListDetailComponent},
            {path: 'supplierpricelist', component: SupplierPriceListListComponent},
            {path: 'supplierpricelist/:id', component: SupplierPriceListDetailComponent},
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [ClientGuard],
    },
    {
        path: 'handleToken',
        component: HandleTokenComponent,
    },
    {
        path: '**',
        component: ErrorsComponent,
        canActivate: [ClientGuard],
        children: [
            {path: '**', component: PageNotFoundComponent},
        ]
    }
];
